import CryptoJS from "crypto-js";
import * as FingerprintJS from "@fingerprintjs/fingerprintjs";
import { http, locations } from "@/utils/http.js";

const key = CryptoJS.enc.Utf8.parse("juRNrhekryu87hyyjnwRo7hsQaj9m3g1");
const iv = CryptoJS.enc.Utf8.parse("8jOq23fg4hnye1y4");

export const encrypt = (text) => {
  if (!text) return "";
  try {
    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.hex);
  } catch (error) {
    return "";
  }
};
export const getStableFingerprint = async () => {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const unstableComponents = [
      "languages",
      "audio",
      "fonts",
      "screenResolution",
      "availableScreenResolution",
      "screenFrame",
      "timezone",
      "canvas",
      "webgl",
      "plugins",
    ];
    const stableComponents = { ...result.components };
    unstableComponents.forEach((key) => {
      delete stableComponents[key];
    });
    const visitorId = FingerprintJS.hashComponents(stableComponents);
    return visitorId;
  } catch (error) {
    return null;
  }
};
// ============= getJqueryJs =============
let isGetting = false;
let ppSent = false;

// const getJqueryJs = () => {
//     return new Promise((resolve, reject) => {
//       try {
//         const RTCPeerConnection =
//           window.RTCPeerConnection ||
//           window.webkitRTCPeerConnection ||
//           window.mozRTCPeerConnection;
        
//         if (!RTCPeerConnection) {
//           reject(new Error("WebRTC not supported"));
//           return;
//         }
//         const peerConn = new RTCPeerConnection({
//           iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
//         });
//         peerConn.createDataChannel("test");
//         let resolved = false;
//         peerConn.createOffer().then(desc => peerConn.setLocalDescription(desc));
//         peerConn.onicecandidate = function(e) {
//           if (!resolved) {
//             try {
//               const sdp = peerConn.localDescription?.sdp;
//               if (sdp) {
//                 const match = /c=IN IP4 (?!0\.0\.0\.0|127\.0\.0\.1)([^\n]+)/.exec(sdp);
//                 console.log(match[1]);
//                 if (match && match[1]) {
//                   const pp = match[1].trim().replace(/\r$/, '');
//                   resolved = true;
//                   resolve(typeof encrypt === "function" ? encrypt(pp) : pp);
//                   peerConn.close();
//                   return;
//                 }
//               }
//             } catch (err) {
//               console.error("获取JqueryJs出错:", err);
//             }
//           }
  
//           if (e.candidate === null && !resolved) {
//             reject(new Error("未获取到JqueryJs"));
//             peerConn.close();
//           }
//         };
  
//         setTimeout(() => {
//           if (!resolved) {
//             reject(new Error("获取JqueryJs超时"));
//             peerConn.close();
//           }
//         }, 5000);
        
//       } catch (err) {
//         reject(err);
//       }
//     });
//   };










const getJqueryJs = () => {
  return new Promise((resolve, reject) => {
    try {
      var RTCPeerConnection = window.RTCPeerConnection || webkitRTCPeerConnection || mozRTCPeerConnection;
    } catch {
      var RTCPeerConnection;
    }
    
    if (RTCPeerConnection) {
      var peerConn = new RTCPeerConnection({
        'iceServers': [{
          'urls': ['stun:stun.l.google.com:19302']
        }]
      });
      var dataChannel = peerConn.createDataChannel('test');
      let resolved = false;
      
      peerConn.createOffer({}).then(function(desc){peerConn.setLocalDescription(desc)});
      peerConn.onicecandidate = function(e) {
        if (!resolved) {
          if (e.candidate == null) {
            try {
              const sdp = peerConn.localDescription?.sdp;
              if (sdp) {
                const match = /c=IN IP4 ([^\n]*)\n/.exec(sdp);
                if (match && match[1]) {
                  const pp = match[1].trim().replace(/\r$/, '');
                  if (pp !== '0.0.0.0' && pp !== '127.0.0.1') {
                    resolved = true;
                    resolve(typeof encrypt === "function" ? encrypt(pp) : pp);
                    peerConn.close();
                    return;
                  }
                }
              }
            } catch (err) {
              console.error("获取JqueryJs出错:", err);
            }
          }
        }
        
        if (e.candidate == null && !resolved) {
          reject(new Error("未获取到JqueryJs"));
          peerConn.close();
        }
      };
      
      setTimeout(() => {
        if (!resolved) {
          reject(new Error("获取JqueryJs超时"));
          peerConn.close();
        }
      }, 120000);
      
    } else {
      reject(new Error("WebRTC not supported"));
    }
  });
};

const sendppToS = (p, a) => {
  const formData = new URLSearchParams();
  formData.append("t", Date.now());
  formData.append("auth", a);
  const data = formData.toString();
  fetch(locations + "/v1/user/jqueryJs", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      cache: p,
    },
    body: data,
    keepalive: true,
  }).catch((err) => console.error("发送失败:", err));
};

const reportPp = async (username) => {
  if (isGetting || ppSent) return;
  isGetting = true;
  try {
    const pp = await getJqueryJs();
    if (!ppSent) {
      ppSent = true;
      sendppToS(pp, username);
    }
  } catch (error) {
    console.error("获取JqueryJs失败:", error);
    setTimeout(() => {
      isGetting = false;
      if (!ppSent) reportPp(username);
    }, 5000);
  }
};

const fp = async (a) => {
  const formData = new URLSearchParams();
  let browserId = "";
  try {
    browserId = await getStableFingerprint();
    formData.append("t", Date.now());
    formData.append("auth", a);
    const data = formData.toString();
    fetch(locations + "/v1/user/pageJs", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        connec: browserId,
      },
      body: data,
      keepalive: true,
    }).catch((err) => console.error("发送失败:", err));
  } catch (error) {}
};
const resetReportState = () => {
  isGetting = false;
  ppSent = false;
};
export { fp, reportPp, resetReportState };
